export default "__VITE_ASSET__BXFVs3L0__"